import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.994 9.979a.75.75 0 0 1 .599-.186 4.5 4.5 0 1 1-4.869 3.055.75.75 0 0 1 1.159-.369q.524.389 1.135.639a6.75 6.75 0 0 1 1.976-3.14m.742 1.366a5.23 5.23 0 0 0-1.424 2.852.75.75 0 0 1-.92.615A6.7 6.7 0 0 1 9 14.303a3 3 0 1 0 3.736-2.958",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.457 1.995a.75.75 0 0 1 .506.295 7.46 7.46 0 0 0 2.717 2.25A9 9 0 1 1 5.496 6.534a.75.75 0 0 1 1.152.081 7.6 7.6 0 0 0 1.705 1.716 9.74 9.74 0 0 1 3.539-6.177.75.75 0 0 1 .565-.16m-.183 1.82a8.22 8.22 0 0 0-2.523 5.802.75.75 0 0 1-1.091.656A9 9 0 0 1 6.019 8.23a7.5 7.5 0 1 0 9.015-2.336 9 9 0 0 1-2.76-2.078",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }